<template>
  <div>
    <div id="id-for">
      <div class="form-header">
        <div style="display: flex">
          <span class="span-name">
            {{ this.$t('answers.answersDetails.treatments.to') }}
          </span>
          <template v-if="userProfile.permissions.answers.anonymous_profile"
            ><input
              value="***************"
              class="treatments-input-for form-control"
              :disabled="this.habilitFields"
          /></template>
          <template v-else>
            <input
              v-model="toEmail"
              class="treatments-input-for form-control"
              :disabled="this.habilitFields"
            />
          </template>
        </div>
        <div style="margin-top: 10px; display: flex">
          <div class="fields">
            <span class="span-name">
              {{ this.$t('answers.answersDetails.treatments.subject') }}
            </span>
            <input
              v-model="emailSubject"
              class="form-control left-name"
              :disabled="this.habilitFields"
            />
          </div>

          <div class="fields">
            <span class="span-name left-name">
              {{ this.$t('answers.answersDetails.treatments.from') }}
            </span>
            <input
              v-model="emailSender"
              class="form-control left-name"
              :disabled="this.habilitFields"
            />
          </div>
        </div>

        <!--
        <div
          v-if="
            this.userAuth.companyId !== '5e18ccd0dc36a60022491bdf' &&
            this.userAuth.companyId !== '61965aa04be7ea63c8f83435' &&
            this.userAuth.companyId !== '5eea25739b8df13f10e8da40'
          "
          style="margin-top: 10px; display: flex;"
        >
        -->
        <div style="margin-top: 10px; display: flex">
          <span class="span-name">
            {{ this.$t('answers.answersDetails.treatments.template') }}
          </span>
          <b-form-select
            style="width: 100%; margin-left: 26px"
            @change="handleTemplateSelected"
            v-model="templateSelected"
            :options="templateOptionsLean"
          ></b-form-select>
        </div>
      </div>

      <div class="col-12" style="margin-top: 70px">
        <wysiwyg
          api-key="no-api-key"
          license_key="gpl2"
          tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
          :disabled="this.habilitFields"
          v-model="emailText"
          :init="{
            menubar: false,
            statusbar: false,
            height: 600,
            language: $t('newAction.stepOne.editorLanguage'),
            plugins: 'link image lists hr emoticons',
            toolbar:
              'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code',
            lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
            font_formats:
              'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
            image_description: false,
            image_title: false,
            content_style: 'img {max-width: 100%; max-height: 100%}',
            image_dimensions: false,
            file_picker_types: 'image',
            images_upload_handler: imagesUploadHandlerBody,
            relative_urls: false,
            remove_script_host: false
          }"
        />
      </div>
      <button
        @click="sendMail"
        :disabled="this.habilitFields"
        class="btn btn-primary treatments-send"
      >
        {{ this.$t('answers.answersDetails.treatments.send') }}
        <i class="fas fa-paper-plane"></i>
      </button>

      <div class="container">
        <h5>
          {{ $t('closetheloop.configureTemplate.saveTemplate') }}
        </h5>
        <div class="search-answers" style="display: flex">
          <input
            type="text"
            class="form-control"
            style="width: 50%"
            id="input-template-name"
            :placeholder="
              $t('closetheloop.configureTemplate.saveTemplatePlaceholder')
            "
            v-model="newTemplateName"
          />
          <button class="btn btn-outline-primary" @click="handleSaveTemplate">
            {{ $t('closetheloop.configureTemplate.saveButton') }}
          </button>
          <button
            style="margin-left: 10px; border-radius: 5px"
            id="update-template"
            :disabled="disabled"
            @click="updateTemplate"
          >
            {{ this.$t('answers.answersDetails.treatments.updateTemplate') }}
          </button>
        </div>
      </div>
    </div>
    <div id="id-responsible">
      <div class="col-lg-12">
        <idx-card
          :title="`${this.$t('answers.answersDetails.treatments.feed')}`"
        >
          <span style="padding-left: 6px">
            <i
              style="
                color: #4ce595;
                cursor: pointer;
                font-size: 25px;
                margin-bottom: 15px;
              "
              class="fas fa-sync-alt"
              @click="refresh()"
              title="Refresh"
            ></i>
          </span>
          <div class="container" style="background-color: #f8f9fa">
            <div class="row">
              <div class="col-lg-12">
                <ul class="message timeline">
                  <li
                    v-for="(allAnswersEmail, index) in allAnswers"
                    :key="index"
                    class="timeline-item bg-white rounded ml-3 p-4 shadow"
                  >
                    <div
                      class="position-share"
                      v-if="allAnswers[index].type === 'inbound'"
                    >
                      <i
                        @click="replyEmail"
                        class="fa fa-share"
                        style="cursor: pointer"
                      ></i>
                    </div>

                    <div class="timeline-arrow" />

                    <p
                      style="font-size: 12px; color: #000; padding-bottom: 10px"
                      class="h5 mb-0"
                    >
                      <strong>De:</strong>
                      {{ allAnswers[index].message.from }}
                    </p>

                    <p
                      style="font-size: 12px; padding-bottom: 10px"
                      class="h5 mb-0"
                      v-if="allAnswers[index].message.to"
                    >
                      <strong>Para:</strong>
                      {{ allAnswers[index].message.to }}
                    </p>

                    <p
                      style="font-size: 12px; padding-bottom: 10px"
                      class="h5 mb-0"
                    >
                      <strong>Assunto</strong>:
                      {{ allAnswers[index].message.subject }}
                    </p>

                    <p class="small text-gray">
                      {{ allAnswers[index].date }}
                    </p>

                    <template v-if="allAnswers[index].type === 'inbound'">
                      <span
                        id="messageText"
                        name="messageText"
                        v-html="getHtmlNormalizedHtml(allAnswers[index].message.html, allAnswers[index].emailAttachments)"
                      >
                      </span>
                    </template>
                    <template v-else>
                      <span
                        id="messageText"
                        name="messageText"
                        v-html="getHtmlNormalizedHtml(allAnswers[index].message.text, allAnswers[index].emailAttachments)"
                      >
                      </span
                    ></template>
                    <div
                      v-if="
                        allAnswers[index].emailAttachments &&
                        allAnswers[index].emailAttachments.length
                      "
                      class="mt-4"
                    >
                      <a
                        style="color: #777777"
                        download
                        v-for="(attach, index) in allAnswers[index]
                          .emailAttachments"
                        :key="index"
                        :href="attach.url"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'paperclip']"
                          style="font-size: 16px"
                        />
                        {{
                          attach.realName
                            ? attach.realName
                            : `Anexo-${index + 1}`
                        }}
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <feed-item style="display: none" />
        </idx-card>
      </div>
    </div>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import FeedItem from '@/components/molecules/treatment-feed-item';
import swal from 'sweetalert';
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  components: { IdxCard, FeedItem },

  data: () => ({
    toEmail: [],
    habilitFields: false,
    emailSubject: 'Retorno Equipe Experiência do Cliente',
    emailText: '',
    emailSender: 'IndeCX',
    historicMessage: ' ',
    historicFrom: null,
    historicSubject: null,
    historicTo: null,
    historicDate: null,
    allAnswers: [],
    templateSelected: null,
    templateOptions: [],
    userAuth: null,
    templateNameSelected: null,
    newTemplateName: null,
    disabled: true,
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.emailSender = this.$store.state.companies.company.name;
    this.getAnswers();
    this.getTemplates();

    if (this.oneAnswer.anonymousResponse === true) {
      this.habilitFields = true;
    }
  },

  computed: {
    ...mapState('treatments', ['oneAnswer']),
    ...mapState('authentication', ['userProfile']),

    templateOptionsLean() {
      return this.templateOptions.map((el) => ({
        value: el.value,
        text: el.text,
      }));
    },
  },

  watch: {
    templateSelected: function watchTemplateSelected(value) {
      let template;

      for (let i = 0; i < this.templateOptions.length; i += 1) {
        if (this.templateOptions[i].value === value) {
          template = this.templateOptions[i];
        }
      }

      if (value && template.type !== 'default') {
        document.getElementById('update-template').style.color = '#4ce595';

        document.getElementById('update-template').style.borderColor =
          '#4ce595';

        document.getElementById('update-template').onmouseover =
          function hoverButtonOver() {
            this.style.backgroundColor = '#4ce595';
            this.style.color = '#fff';
          };

        document.getElementById('update-template').onmouseout =
          function hoverButtonOut() {
            this.style.backgroundColor = '#fff';
            this.style.color = '#4ce595';
          };

        this.disabled = false;
      } else {
        document.getElementById('update-template').style.color = '#c1c1c1';

        document.getElementById('update-template').style.borderColor =
          '#c1c1c1';

        this.emailText = '';

        this.disabled = true;
      }
    },
  },

  methods: {
    ...mapActions('treatments', [
      'updateResponsible',
      'setCostumerNotifications',
      'updateStatus',
    ]),

    getHtmlNormalizedHtml(html, emailAttachments) {
      const normalizedLink = this.getHtmlNormalizedLink(html);
      const normalizedImages = this.getHtmlNormalizedImages(normalizedLink, emailAttachments);
      return normalizedImages;
    },

    getHtmlNormalizedLink(html) {

      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      const links = tempElement.getElementsByTagName('a');
      const prefixes = [
        'https://indecx.pe/survey-link',
        'https://indecx.pe/../survey-link',
        'https://indecx.pe/pesquisa',
        'https://indecx.pe/../pesquisa',
        'https://app-indecx.com/survey-link',
        'https://app-indecx.com/../survey-link',
        'https://app-indecx.com/pesquisa',
        'https://app-indecx.com/../pesquisa'
      ];

      for (let i = 0; i < links.length; i++) {
        const link = links[i];
        var href = link.getAttribute('href');

        if ((href && prefixes.some(prefix => href.startsWith(prefix))) || (href && href.includes('/click?upn'))) {
          link.removeAttribute('href');
        }
      }

      return tempElement.innerHTML;

    },

    // solução para contornar o protocolo CID usado pelos clientes de email para renderizar imagens no feed
    getHtmlNormalizedImages(html, emailAttachments) {

      // Cria um elemento DOM temporário para manipular o HTML
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      // Seleciona todas as imagens no HTML
      const images = tempElement.getElementsByTagName('img');

      // Percorre todas as imagens
      for (let i = 0; i < images.length; i++) {
          const image = images[i];
          const src = image.getAttribute('src');
          const alt = image.getAttribute('alt');

          // Verifica se o atributo src começa com "cid:"
          if (src && src.startsWith('cid:')) {
            // Busca no array emailAttachments um objeto cujo realName corresponda ao valor do atributo alt
            const attachment = emailAttachments.find(attach => attach.realName === alt);

            // Se um objeto correspondente for encontrado, substitui o atributo src da imagem pelo valor do campo src do objeto encontrado
            if (attachment && attachment.url) {
              image.setAttribute('src', attachment.url);
            }
          }
      }

      // Retorna o HTML normalizado
      return tempElement.innerHTML;
      },

    async updateTemplate() {
      await api.put(
        'template-treatment',
        {
          idTemplate: this.templateSelected,
          html: this.emailText,
        },
        { headers: { 'x-access-token': this.userAuth.token } },
      );

      this.getTemplates(true);

      swal({
        title: 'Template atualizado',
        text: 'Seu template foi alterado com sucesso!',
        icon: 'success',
        buttons: 'Ok',
      });
    },

    async handleSaveTemplate() {
      if (!this.emailSubject || !this.emailSender || !this.newTemplateName) {
        swal(
          'Oops...',
          this.$t('closetheloop.configureTemplate.saveErrorDescription'),
          'error',
        );
        return;
      }

      const response = await api.post(
        '/close-the-loop/templates',
        {
          name: this.newTemplateName,
          subject: this.emailSubject,
          sender: this.emailSender,
          html: this.emailText,
        },
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      swal(
        this.$t('closetheloop.configureTemplate.templatedCreatedTitle'),
        this.$t('closetheloop.configureTemplate.templatedCreatedDescription'),
        'success',
      );

      this.templateOptions.push({
        value: response.data._id,
        text: response.data.name,
        subject: response.data.subject,
        sender: response.data.sender,
        html: response.data.html,
      });

      this.templateSelected = response.data._id;

      this.templateNameSelected = response.data.name;

      this.newTemplateName = null;
    },

    async getTemplates(updateSelect) {
      const response = await api.get('/treatments/templates', {
        headers: { 'x-access-token': this.userAuth.token },
      });

      if (updateSelect) {
        this.templateOptions = [];
      }

      this.templateOptions.push({
        value: null,
        text: this.$t('closetheloop.configureTemplate.selectTemplate'),
        subject: null,
        sender: null,
        html: null,
      });

      response.data.forEach((el) => {
        this.templateOptions.push({
          value: el._id,
          text: el.name,
          subject: el.subject,
          sender: el.sender,
          html: el.html,
          type: el.type,
        });
      });
    },

    handleTemplateSelected() {
      const template = this.templateOptions.find(
        (el) => el.value === this.templateSelected,
      );
      this.emailText = template.html;
      this.emailSubject = template.subject;
      this.emailSender = template.sender;
    },

    async refresh() {
      this.getAnswers();
    },

    async replyEmail() {
      this.toEmail = this.oneAnswer.email;

      this.historicMessage = this.allAnswers[0].message.html;
      this.emailSubject = this.allAnswers[0].message.subject;

      this.historicFrom =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>De</strong>:' +
        `${this.allAnswers[0].message.from}` +
        '</p>';

      this.historicTo =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Para</strong>:' +
        `${this.allAnswers[0].message.to}` +
        '</p>';

      this.historicSubject =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Assunto</strong>:' +
        `${this.allAnswers[0].message.subject}` +
        '</p>';

      this.historicDate =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Assunto</strong>:' +
        `${this.allAnswers[0].date}` +
        '</p>';

      this.historicDate =
        '<p style="font-size: 14px;" class="small text-gray"><i class="fa fa-clock-o mr-1"></i>' +
        `${this.allAnswers[0].date}` +
        '</p>';

      const hr = '<br /><br /><br /><br /><br /><br /><hr />';

      this.historicMessage =
        hr +
        this.historicFrom +
        this.historicTo +
        this.historicSubject +
        this.historicDate +
        this.historicMessage;

      this.emailText = this.historicMessage;
    },

    async sendMail() {
      if (!this.userProfile.permissions.answers.anonymous_profile) {
        swal({
          title: 'Atenção',
          text: this.$t(
            'Tem certeza de que quer enviar essa mensagem ao cliente?',
          ),
          icon: 'warning',
          buttons: ['Não', 'Sim'],
        }).then(async (yes) => {
          if (yes) {
            if (this.oneAnswer.treatments.responsible === 'none') {
              EventBus.$emit('changeResponsible', this.userAuth._id);

              this.updateResponsible({
                token: this.userAuth.token,
                answerId: this.oneAnswer._id,
                data: { responsible: this.userAuth._id },
              });
            }

            await api.post(
              `/email-treatments/${this.oneAnswer._id}`,
              {
                emailText: this.emailText,
                emailTo: this.toEmail,
                emailSubject: this.emailSubject,
                from: this.emailSender
                  ? this.emailSender
                  : this.$store.state.companies.company.name,
                headers: { 'x-access-token': this.userAuth.token },
              },
              {
                headers: {
                  'x-access-token': this.userAuth.token,
                },
              },
            );

            swal({
              title: 'E-mail enviado com sucesso!',
              icon: 'success',
            });

            // limpar campos após enviar email
            this.emailText = '';
            this.emailTo = '';
            this.toEmail = '';
            this.emailSender = this.$store.state.companies.company.name;

            await this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.oneAnswer._id,
              order: 'latest'
            });

            this.getAnswers();
          }
        });
      } else {
        swal({
          title: 'Seu perfil está no modo anônimo!',
          icon: 'warning',
        });
      }
    },

    async getAnswers() {
      if (this.oneAnswer.anonymousResponse !== true) {
        this.toEmail = this.oneAnswer.email;
      }

      const response = await api.get(
        `/email-treatments/${this.oneAnswer._id}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.allAnswers = response.data;

      for (let i = 0; i < this.allAnswers.length; i += 1) {
        const message = new DOMParser().parseFromString(
          this.allAnswers[i].message.text,
          'text/html',
        );

        const textContent = message.documentElement.innerHTML;

        this.allAnswers[i].message.text = textContent;

        this.allAnswers[i].date = format(
          new Date(this.allAnswers[i].date),
          'dd/MM/yyyy HH:mm',
        );
      }
    },

    async imagesUploadHandlerBody(blobInfo, success, failure) {
      if (!blobInfo) {
        return;
      }

      try {
        const formData = new FormData();

        formData.append('file', blobInfo.blob(), blobInfo.filename());

        const response = await api.post(
          '/close-the-loop/image-body',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': this.userAuth.token,
            },
          },
        );

        success(response.data);
      } catch (error) {
        failure(error);
      }
    },
  },
};
</script>

<style scoped>
#update-template {
  color: #c1c1c1;
  border: 1px solid #c1c1c1;
  background: #fff;
  padding: 0.375rem 0.75rem;
}
</style>

<style>
.treatments-input-for {
  display: inline;
  margin-left: 62px;
}

.form-header {
  margin-bottom: -52px;
  padding: 12px;
}

.fields {
  display: flex;
  width: 50%;
}

.left-name {
  margin-left: 35px;
}

.span-name {
  margin-top: 8px;
}

.treatments-send {
  float: right;
  margin-top: 5px;
  margin-right: 12px;
}

#id-for {
  width: 50%;
  display: inline-block;
}

#id-responsible {
  float: right;
  width: 50%;
  max-height: 705px;
  overflow: auto;
}

#more {
  display: none;
}

h2.h5.mb-0 {
  font-weight: 100;
}

ul.timeline {
  list-style-type: none;
  position: relative;
  padding-left: 1.5rem;
}

ul.timeline:before {
  content: ' ';
  background: #fff;
  display: inline-block;
  position: absolute;
  left: 16px;
  width: 4px;
  height: 100%;
  z-index: 400;
  border-radius: 1rem;
}

li.timeline-item {
  margin: 20px 0;
}

.timeline-arrow {
  border-top: 0.5rem solid transparent;
  border-right: 0.5rem solid #fff;
  border-bottom: 0.5rem solid transparent;
  display: block;
  position: absolute;
  left: 2rem;
}

li.timeline-item::before {
  content: ' ';
  background: #ddd;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #fff;
  left: 11px;
  width: 14px;
  height: 14px;
  z-index: 400;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.position-share {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/treatment-details/treatments-reply/index.vue